import { BASE_URL, VA_TYPE } from "../../config";
import {
	SET_DETAIL_LOAN,
	SET_VA_LOAN,
	SET_INFO_DOCS_LOAN,
	SET_ERROR_STATE,
	REQ_DETAIL_LOAN_DONE,
	REQ_DETAIL_LOAN,
	SET_INFO_COLLATERAL_LOAN,
	SET_OFFERING_HISTORY,
	SET_STATUS_HISTORY,
	SET_MEMO_HISTORY,
	SET_DIGISIGN_CHECK,
} from "../../utils/constants/actionTypes";
import { GLoanDetail, GVA, GInfoDoc, GInfoCollateral, GOfferingHistory, GStatusHistory, GMemoHistory, get_digisign_page, get_digisign_check, URL_API_GET_TIPE_JAMINAN } from "../../config/api";
import bugsnagClient from "../../config/bugsnag";
import axios from "axios";

export const asyncLoanDetail = (ClientID, loanCode) => async (dispatch) => {
	dispatch({ type: SET_DETAIL_LOAN, payload: null });
	dispatch({ type: REQ_DETAIL_LOAN });

	const optHeader = { method: "GET", credentials: "include", headers: { "X-Client-ID": ClientID } };
	let loanDetail = fetch(`${BASE_URL}/loan/invoice-financing/${loanCode}`, optHeader);
	let colateral = fetch(`${BASE_URL}/loan/invoice-financing/${loanCode}/collateral`, optHeader);
	let financialStatement = fetch(`${BASE_URL}/document/loan/invoice-financing/${loanCode}/financial-statement`, optHeader);

	Promise.all([loanDetail, colateral, financialStatement])
		.then(async (res) => {
			const resLoanDetail = await res[0].json();
			const resColateral = await res[1].json();
			const resFinancial = await res[2].json();

			if (res[0].status === 200 && res[1].status === 200 && res[2].status === 200) {
				let data = resLoanDetail.result.loan;
				data = {
					...data,
					infoColateral: resColateral.result.loan,
					infoDocs: resFinancial.result.document,
				};

				dispatch({ type: SET_DETAIL_LOAN, payload: data });
			} else {
				console.log("1. Error Loan Detail AsyncLoanDetail", resLoanDetail.status.message);
				console.log("2. Error Colateral AsyncLoanDetail", resColateral.status.message);
				console.log("3. Error Financial AsyncLoanDetail", resFinancial.status.message);

				dispatch({ type: SET_ERROR_STATE, payload: "Data Pinjaman Gagal didapatkan" });
				dispatch({ type: REQ_DETAIL_LOAN_DONE });
			}
		})
		.catch((err) => {
			dispatch({ type: SET_ERROR_STATE, payload: err.message });
			dispatch({ type: REQ_DETAIL_LOAN_DONE });
		});
};

export const LoanDetail = (ClientID, loanCode, cb) => async (dispatch) => {
	dispatch({ type: REQ_DETAIL_LOAN });
	try {
		let res = await fetch(`${BASE_URL}/loan/invoice-financing/${loanCode}`, {
			method: "GET",
			credentials: "include",
			headers: {
				"X-Client-ID": ClientID,
			},
		});
		let hasil = await res.json();
		if (res.status === 200) {
			let data = hasil.result.loan;
			const statusVA = ["IN1", "WD0", "DS1", "WD1", "PD1"];
			let findStatus = statusVA.indexOf(data.loanStatus);
			let statusPinjaman = ["PB0", "IN1", "WD0", "DS1", "WD1", "CC0", "CP1", "FL1", "NPL"];
			let findStatusPinjaman = statusPinjaman.indexOf(data.loanStatus);

			await axios({
				method: "get",
				url: `${BASE_URL}${URL_API_GET_TIPE_JAMINAN(data.productUID)}`,
				headers: {
					"X-Client-ID": ClientID,
					"Content-Type": "application/json",
				},
			}).then((res) => {
				data.nameProductMapping = res.data.result.product.productName;
			});

			dispatch({ type: SET_DETAIL_LOAN, payload: data });
			dispatch(GetInfoDocs(ClientID, loanCode));
			dispatch(GetInfoCollateral(ClientID, loanCode));
			dispatch(GetOfferingHistory(ClientID, loanCode));
			if (findStatus !== -1) {
				dispatch(GetVA(ClientID, loanCode));
			}
			if (findStatusPinjaman !== -1) {
				dispatch(GetStatusHistory(ClientID, loanCode));
				dispatch(GetMemoHistory(ClientID, loanCode));
			}

			if (data.isDigitalSignature && data.loanAgreement) {
				dispatch(GetDigisignCheck(ClientID, data.loanAgreement.agreementDocumentUID));
				//console.log('Digisign Check Kepanggil');
			} else {
				//console.log('Digisign Check Gak Kepanggil', data);
			}

			if (cb) {
				cb(data);
			}
		} else if (res.status === 500) {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.code + " - " + hasil.status.message });
			dispatch({ type: REQ_DETAIL_LOAN_DONE });
			bugsnagClient.notify(new Error(`LoanDetail.js/LoanDetail (line 46) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
		} else {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.message });
			dispatch({ type: REQ_DETAIL_LOAN_DONE });
			bugsnagClient.notify(new Error(`LoanDetail.js/LoanDetail (line 50) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
		}
	} catch (err) {
		dispatch({ type: SET_ERROR_STATE, payload: err.message });
		dispatch({ type: REQ_DETAIL_LOAN_DONE });
		bugsnagClient.notify(new Error(`LoanDetail.js/LoanDetail (line 55) ===> catch - ${err.message}`));
	}
};

export const GetVA = (ClientID, loanCode) => async (dispatch) => {
	dispatch({ type: REQ_DETAIL_LOAN });
	try {
		let res = await fetch(`${BASE_URL}${GVA(loanCode, VA_TYPE)}`, {
			method: "GET",
			credentials: "include",
			headers: {
				"X-Client-ID": ClientID,
			},
		});
		let hasil = await res.json();
		if (res.status === 200) {
			dispatch({ type: SET_VA_LOAN, payload: hasil.result.virtualAccount });
		} else if (res.status === 500) {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.code + " - " + hasil.status.message });
			dispatch({ type: REQ_DETAIL_LOAN_DONE });
			bugsnagClient.notify(new Error(`LoanDetail.js/GetVA (line 75) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
		} else {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.message });
			dispatch({ type: REQ_DETAIL_LOAN_DONE });
			bugsnagClient.notify(new Error(`LoanDetail.js/GetVA (line 79) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
		}
	} catch (err) {
		dispatch({ type: SET_ERROR_STATE, payload: err.message });
		dispatch({ type: REQ_DETAIL_LOAN_DONE });
		bugsnagClient.notify(new Error(`LoanDetail.js/GetVA (line 84) ===> catch - ${err.message}`));
	}
};

export const GetInfoDocs = (ClientID, loanCode) => async (dispatch) => {
	dispatch({ type: REQ_DETAIL_LOAN });
	try {
		let res = await fetch(`${BASE_URL}${GInfoDoc(loanCode)}`, {
			method: "GET",
			credentials: "include",
			headers: {
				"X-Client-ID": ClientID,
			},
		});
		let hasil = await res.json();
		if (res.status === 200) {
			dispatch({ type: SET_INFO_DOCS_LOAN, payload: hasil.result.document });
		} else if (res.status === 500) {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.code + " - " + hasil.status.message });
			dispatch({ type: REQ_DETAIL_LOAN_DONE });
			bugsnagClient.notify(new Error(`LoanDetail.js/GetInfoDocs (line 104) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
		} else {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.message });
			dispatch({ type: REQ_DETAIL_LOAN_DONE });
			bugsnagClient.notify(new Error(`LoanDetail.js/GetInfoDocs (line 108) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
		}
	} catch (err) {
		dispatch({ type: SET_ERROR_STATE, payload: err.message });
		dispatch({ type: REQ_DETAIL_LOAN_DONE });
		bugsnagClient.notify(new Error(`LoanDetail.js/GetInfoDocs (line 113) ===> catch - ${err.message}`));
	}
};

export const GetInfoCollateral = (ClientID, loanCode) => async (dispatch) => {
	dispatch({ type: REQ_DETAIL_LOAN });
	try {
		let res = await fetch(`${BASE_URL}${GInfoCollateral(loanCode)}`, {
			method: "GET",
			credentials: "include",
			headers: {
				"X-Client-ID": ClientID,
			},
		});
		let hasil = await res.json();
		if (res.status === 200) {
			dispatch({ type: SET_INFO_COLLATERAL_LOAN, payload: hasil.result.loan });
		} else if (res.status === 500) {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.code + " - " + hasil.status.message });
			dispatch({ type: REQ_DETAIL_LOAN_DONE });
			bugsnagClient.notify(new Error(`LoanDetail.js/GetInfoCollateral (line 133) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
		} else {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.message });
			dispatch({ type: REQ_DETAIL_LOAN_DONE });
			bugsnagClient.notify(new Error(`LoanDetail.js/GetInfoCollateral (line 137) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
		}
	} catch (err) {
		dispatch({ type: SET_ERROR_STATE, payload: err.message });
		dispatch({ type: REQ_DETAIL_LOAN_DONE });
		bugsnagClient.notify(new Error(`LoanDetail.js/GetInfoCollateral (line 142) ===> catch - ${err.message}`));
	}
};

export const GetOfferingHistory = (ClientID, loanCode) => async (dispatch) => {
	dispatch({ type: REQ_DETAIL_LOAN });
	try {
		let res = await fetch(`${BASE_URL}${GOfferingHistory(loanCode)}`, {
			method: "GET",
			credentials: "include",
			headers: {
				"X-Client-ID": ClientID,
			},
		});
		let hasil = await res.json();
		if (res.status === 200) {
			dispatch({ type: SET_OFFERING_HISTORY, payload: hasil.result.loan.offerings });
		} else if (res.status === 500) {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.code + " - " + hasil.status.message });
			dispatch({ type: REQ_DETAIL_LOAN_DONE });
			bugsnagClient.notify(new Error(`LoanDetail.js/GetOfferingHistory (line 162) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
		} else {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.message });
			dispatch({ type: REQ_DETAIL_LOAN_DONE });
			bugsnagClient.notify(new Error(`LoanDetail.js/GetOfferingHistory (line 166) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
		}
	} catch (err) {
		dispatch({ type: SET_ERROR_STATE, payload: err.message });
		dispatch({ type: REQ_DETAIL_LOAN_DONE });
		bugsnagClient.notify(new Error(`LoanDetail.js/GetOfferingHistory (line 171) ===> catch - ${err.message}`));
	}
};

export const GetStatusHistory = (ClientID, loanCode) => async (dispatch) => {
	dispatch({ type: REQ_DETAIL_LOAN });
	try {
		let res = await fetch(`${BASE_URL}${GStatusHistory(loanCode)}`, {
			method: "GET",
			credentials: "include",
			headers: {
				"X-Client-ID": ClientID,
			},
		});
		let hasil = await res.json();
		if (res.status === 200) {
			dispatch({ type: SET_STATUS_HISTORY, payload: hasil.result.loan.status });
		} else if (res.status === 500) {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.code + " - " + hasil.status.message });
			dispatch({ type: REQ_DETAIL_LOAN_DONE });
			bugsnagClient.notify(new Error(`LoanDetail.js/GetStatusHistory (line 191) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
		} else {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.message });
			dispatch({ type: REQ_DETAIL_LOAN_DONE });
			bugsnagClient.notify(new Error(`LoanDetail.js/GetStatusHistory (line 195) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
		}
	} catch (err) {
		dispatch({ type: SET_ERROR_STATE, payload: err.message });
		dispatch({ type: REQ_DETAIL_LOAN_DONE });
		bugsnagClient.notify(new Error(`LoanDetail.js/GetStatusHistory (line 200) ===> catch - ${err.message}`));
	}
};

export const GetMemoHistory = (ClientID, loanCode) => async (dispatch) => {
	dispatch({ type: REQ_DETAIL_LOAN });
	try {
		let res = await fetch(`${BASE_URL}${GMemoHistory(loanCode)}`, {
			method: "GET",
			credentials: "include",
			headers: {
				"X-Client-ID": ClientID,
			},
		});
		let hasil = await res.json();
		if (res.status === 200) {
			dispatch({ type: SET_MEMO_HISTORY, payload: hasil.result.loan.memos });
		} else if (res.status === 500) {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.code + " - " + hasil.status.message });
			dispatch({ type: REQ_DETAIL_LOAN_DONE });
			bugsnagClient.notify(new Error(`LoanDetail.js/GetMemoHistory (line 220) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
		} else {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.message });
			dispatch({ type: REQ_DETAIL_LOAN_DONE });
			bugsnagClient.notify(new Error(`LoanDetail.js/GetMemoHistory (line 224) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
		}
	} catch (err) {
		dispatch({ type: SET_ERROR_STATE, payload: err.message });
		dispatch({ type: REQ_DETAIL_LOAN_DONE });
		bugsnagClient.notify(new Error(`LoanDetail.js/GetMemoHistory (line 229) ===> catch - ${err.message}`));
	}
};

export const GetDigisignCheck = (ClientID, DocumentID) => async (dispatch) => {
	dispatch({ type: REQ_DETAIL_LOAN });
	try {
		let res = await fetch(`${BASE_URL}${get_digisign_check(DocumentID)}`, {
			method: "GET",
			credentials: "include",
			headers: {
				"X-Client-ID": ClientID,
			},
		});
		let hasil = await res.json();
		if (res.status === 200) {
			dispatch({ type: SET_DIGISIGN_CHECK, payload: hasil.result.document });
			//console.log(hasil.result);
		} else if (res.status === 500) {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.code + " - " + hasil.status.message });
			dispatch({ type: REQ_DETAIL_LOAN_DONE });
			bugsnagClient.notify(new Error(`LoanDetail.js/GetDigisignCheck (line 285) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
		} else {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.message });
			dispatch({ type: REQ_DETAIL_LOAN_DONE });
			bugsnagClient.notify(new Error(`LoanDetail.js/GetDigisignCheck (line 289) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
		}
	} catch (err) {
		dispatch({ type: SET_ERROR_STATE, payload: err.message });
		dispatch({ type: REQ_DETAIL_LOAN_DONE });
		bugsnagClient.notify(new Error(`LoanDetail.js/GetDigisignCheck (line 294) ===> catch - ${err.message}`));
	}
};

export const GetDigisignPage = (ClientID, DocumentID, UserID, cb) => {
	const params = {
		method: "GET",
		credentials: "include",
		headers: {
			"X-Client-ID": ClientID,
			"Content-Type": "application/json",
		},
	};

	fetch(`${BASE_URL}${get_digisign_page(DocumentID, UserID)}`, params)
		.then(async (res) => {
			const hasil = await res.json();
			if (res.status === 200 || res.status === 201) {
				cb(true, hasil.result.document.url);
			} else {
				cb(false, hasil.status.message);
			}
		})
		.catch((err) => {
			cb(false, err);
		});
};
